var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOffGlyph16X16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#EyeOffGlyph16x16_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.855.147a.5.5 0 0 0-.708.708l3.5 3.498A8.1 8.1 0 0 0 .28 9.399a.5.5 0 1 0 .979.204 7.1 7.1 0 0 1 3.108-4.528L5.95 6.657a3.5 3.5 0 1 0 4.884 4.884l4.313 4.314a.5.5 0 1 0 .708-.708zm7.27 5.857 3.363 3.363a3.5 3.5 0 0 0-3.363-3.363M5.53 3.41l.803.803A6.6 6.6 0 0 1 8 4c3.206 0 6.057 2.327 6.74 5.602a.5.5 0 0 0 .98-.204C14.944 5.674 11.694 3 8 3a7.6 7.6 0 0 0-2.47.41"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "EyeOffGlyph16x16_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgEyeOffGlyph16X16;